const ROLE_DESC: Record<string, { title: string; href: string; desc: string }> = {
  Approver: {
    title: "Approvals",
    href: "/approvals",
    desc: "Review and action your team's pending expense claims.",
  },
  Payroll: {
    title: "Payroll queue",
    href: "/payroll/queue",
    desc: "Process manager-approved claims ready for payment.",
  },
  Finance: {
    title: "Finance",
    href: "/finance/floats",
    desc: "Petty cash floats, top-ups, and cross-home reporting.",
  },
  HomeManager: {
    title: "My home",
    href: "/home/petty-cash",
    desc: "Petty cash float status, log spend, set activity budgets.",
  },
  Admin: {
    title: "Admin",
    href: "/admin/categories",
    desc: "Categories, mileage rates, cost centres, manager overrides.",
  },
};

export default function LandingPage({ roles }: { roles: string[] }) {
  const sections = Object.entries(ROLE_DESC).filter(([role]) => roles.includes(role));

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-semibold text-liaise-navy">Expenses · Admin</h1>
        <p className="text-slate-600 mt-1">Approvers, payroll, finance and home-manager tools.</p>
      </div>

      {sections.length === 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6">
          <h2 className="font-medium text-amber-900">No admin roles assigned</h2>
          <p className="text-amber-800 text-sm mt-2">
            You don't have any approver, payroll, finance, home-manager, or admin role on this account.
            If you think this is a mistake, ask IT to add you to the relevant Entra group.
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sections.map(([role, s]) => (
          <a
            key={role}
            href={s.href}
            className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md hover:border-liaise-navy/30 transition"
          >
            <div className="flex items-center gap-2 mb-2">
              <h2 className="font-medium text-liaise-navy">{s.title}</h2>
              <span className="text-xs bg-liaise-navy/10 text-liaise-navy px-2 py-0.5 rounded">{role}</span>
            </div>
            <p className="text-slate-600 text-sm">{s.desc}</p>
          </a>
        ))}
      </div>
    </div>
  );
}
